export default "__VITE_ASSET__D67FUv3Y__"